import { LinkButton } from '@cian/ui-kit/button';
import { FC } from 'react';

import { MY_CIAN_URL } from 'shared/containers/Superhost/const';

import img from '../assets/superhost-chip.png';

import style from './Preview.css';
import { useDeviceType } from '@cian/ui-kit';

export const Preview: FC = () => {
  const isMobile = useDeviceType() !== 'desktop';

  return (
    <section className={style['preview']}>
      <div className={style['inner']}>
        <div className={style['img-container']}>
          <img className={style['img']} src={img} alt="" />
        </div>
        <div className={style['content']}>
          <h2 className={style['title']}>Как будет выглядеть ваше&nbsp;объявление</h2>
          <div className={style['button-wrapper']}>
            <LinkButton href={MY_CIAN_URL} theme="fill_primary" size={isMobile ? 'M' : 'L'} fullWidth>
              Перейти в личный кабинет
            </LinkButton>
          </div>
        </div>
      </div>
    </section>
  );
};
